import script from "./AutoReplies.vue?vue&type=script&lang=ts&setup=true"
export * from "./AutoReplies.vue?vue&type=script&lang=ts&setup=true"

import "./AutoReplies.vue?vue&type=style&index=0&id=b71367fe&lang=sass"

const __exports__ = script;

export default __exports__